/**
 * custom-phaser-wishlist-brand.js
 * Phaser-only wording for /apps/iwish. Overrides leftover CCC coffee copy when
 * Wishlist Prime admin still has the CCC master template pasted.
 *
 * Loads after custom-shared-wishlist-page.js. Uses CCWishlist.setCopy so the
 * shared render pass owns the text, plus an early DOM patch so first paint is
 * not coffee-branded before the shared module boots.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || !window.document) return;
  if (window.__phaserWishlistBrandLoaded) return;
  window.__phaserWishlistBrandLoaded = true;

  const COPY = {
    deck: 'FPV gear and parts you have set aside. We watch price and stock so you do not have to.',
    emptyTitle: 'Gear you are curious about, and parts you are circling.',
    emptyBody:
      'Tap the heart on any product to set it aside. We will keep an eye on price and stock so you do not have to.',
    printFoot: 'phaserfpv.com.au — saved list',
    accountBody:
      '{n} · {v} tracked here. Sign in and your list follows you — phone, laptop, and the next time you clear your browser. We will flag price drops and restocks on products you have saved.',
    accountBodyFallback:
      'Sign in and it follows you — phone, laptop, and the next time you clear your browser. We will flag price drops and restocks on products you have saved.',
  };

  const NODE_COPY = [
    ['[data-ccw-deck], .ccw-deck', COPY.deck],
    ['[data-ccw-empty-title], .ccw-empty__title', COPY.emptyTitle],
    ['[data-ccw-empty-body], .ccw-empty__body', COPY.emptyBody],
    ['[data-ccw-print-foot], .ccw-print-foot', COPY.printFoot],
  ];

  function setText(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
  }

  function patchNodes() {
    const root = document.querySelector('[data-ccw-root]');
    if (!root) return false;

    for (const [selector, value] of NODE_COPY) {
      setText(root.querySelector(selector), value);
    }

    /* Own the empty-list fallback whenever shared has not filled {n}/{v} yet.
       Do not set __ccwDone — shared refreshStats must still replace this with
       the counted accountBody once items exist. */
    const account = root.querySelector('[data-ccw-account-body]');
    if (account && !account.__ccwDone) {
      setText(account, COPY.accountBodyFallback);
    }

    return true;
  }

  function reg(fn) {
    const NS = window.CCWishlist;
    if (NS && typeof NS.extend === 'function') {
      NS.extend(fn);
      return;
    }
    const queueNs = (window.CCWishlist = window.CCWishlist || {});
    (queueNs.q = queueNs.q || []).push(fn);
  }

  reg(function (api) {
    api.setCopy('deck', COPY.deck);
    api.setCopy('emptyTitle', COPY.emptyTitle);
    api.setCopy('emptyBody', COPY.emptyBody);
    api.setCopy('printFoot', COPY.printFoot);
    api.setCopy('accountBody', COPY.accountBody);
    patchNodes();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchNodes);
  } else {
    patchNodes();
  }

  let tries = 0;
  const timer = window.setInterval(function () {
    const ready = patchNodes();
    tries += 1;
    if (ready || tries >= 25) window.clearInterval(timer);
  }, 100);
})();
